<template>
  <div class="home_wrap" >
    <div class="headers" >
      <div></div>
      <div class="headers_right" >
<!--        <div class="chat" @click="notice" ></div>-->
        <div class="setting" @click="setting" ></div>
      </div>
    </div>

    <div class="user_wrap" >
      <div class="user_left" >
        <div class="user_name" >{{ userVo.nickName }}</div>
        <div class="user_desc" >
          <div>ID：{{ userVo.userCode }}</div>
          <div class="copy" @click="copy" ></div>
          <div v-if="userVo.parentNickName" class="recommend_user" >推荐人：{{ userVo.parentNickName }}</div>
        </div>
        <img src="./img/vip.png" class="vip" v-if="userVo.level === '0'" />
        <img src="./img/shopkeeper.png" class="vip" v-if="userVo.level === '1'" />
        <img src="./img/partner.png" class="vip" v-if="userVo.level === '3'" />
        <img src="./img/ceo.png" class="vip" v-if="userVo.level === '2'" />
      </div>

      <div class="user_img" >
        <img :src="userVo.headImgUrl" />
<!--        <div class="sex_w" ></div>-->
      </div>
    </div>

<!--    <div class="account_wrap" >
      <div>
        <div>账户余额</div>
        <div>
          <span>￥</span>
          <span>{{ this.toThousands(parseInt(accountBalances)) }}</span>
        </div>
      </div>
      <div class="cash_btn" @click="cashApply" >提现</div>
    </div>-->

    <div class="account_wrap" >
      <div class="money_wrap" >
        <div class="title" >奖励金金额</div>
        <div class="money_text" ><span>￥</span>{{ this.toThousands(accountBalances) }}</div>
        <img src="./img/cash.png" class="cash_button" @click="cashApply" />
      </div>
      <div class="cart_wrap" @click="toRecord">
        <div class="title" >购物金金额</div>
        <div class="money_text" ><span>￥</span>{{ this.toThousands(sugarMoney) }}</div>
        <img src="./img/transfer.png" class="transfer_button" @click.stop="toTransfer" />
      </div>
    </div>

    <div class="profit_wrap" >
      <div class="profit_head" @click="turnoverDetail" >
        <div>
          <div class="profit_icon" ></div>
<!--          <div>总收益：{{ this.toThousands(parseInt(profit)) }}</div>-->
          <div>总收益：{{ parseFloat(profit).toFixed(2) }}</div>
        </div>
<!--        <div class="eye" ></div>-->
      </div>

      <div class="profit_statistics_block" >
        <div class="profit_statistics_item today" @click="turnoverDetail" >
          <div class="profit_statistics_title" >今日营业额</div>
          <div class="profit_statistics_money" >
            <span>￥</span>
<!--            <span>{{ this.toThousands(parseInt(dayTurnover)) }}</span>-->
            <span>{{ parseFloat(dayTurnover).toFixed(2) }}</span>
          </div>
        </div>

        <div class="profit_statistics_item month" @click="turnoverDetail" >
          <div class="profit_statistics_title" >本月营业额</div>
          <div class="profit_statistics_money" >
            <span>￥</span>
<!--            <span>{{ this.toThousands(parseInt(monthTurnover)) }}</span>-->
            <span>{{ parseFloat(monthTurnover).toFixed(2) }}</span>
          </div>
        </div>
      </div>

      <div class="all_profit_statistics" >
        <div>
          <span>总</span>
          <span>营业额</span>
        </div>
<!--        <div>￥{{ this.toThousands(parseInt(allTurnover)) }}</div>-->
        <div>￥{{ parseFloat(allTurnover).toFixed(2) }}</div>
      </div>
    </div>

    <div class="draw_wrap" >
      <div class="poster" @click="poster" >
        <div>“</div>
        <div>锁粉海报</div>
        <div>一次锁粉 终身绑定</div>
      </div>

      <div class="draw" @click="draw" >
        <div>“</div>
        <div>积分抽奖</div>
        <div>好礼多多 转不停</div>
      </div>
    </div>

<!--    <div class="opt_list" >
      <div class="opt_item" >
        <img src="./img/daiban.png" />
        <div>我的待办</div>
      </div>

      <div class="opt_item" >
        <img src="./img/haibao.png" />
        <div>我的海报</div>
      </div>

      <div class="opt_item" >
        <img src="./img/zuji.png" />
        <div>我的足迹</div>
      </div>

      <div class="opt_item" >
        <img src="./img/yuncang.png" />
        <div>我的云仓</div>
      </div>
    </div>-->

    <div class="card_wrap"  @click="turnoverDetail" >
      <div class="card_title" >
        <div>团队订单</div>
        <div>{{ this.toThousands(parseInt(allCount)) }} 笔</div>
      </div>

      <div class="card_item" >
        <div>{{ this.toThousands(parseInt(dayCount)) }}</div>
        <div>今日新增</div>
      </div>

      <div class="card_item" >
        <div>{{ this.toThousands(parseInt(monthCount)) }}</div>
        <div>本月新增</div>
      </div>
    </div>

    <div class="card_wrap" @click="myCommunity">
      <div class="card_title" >
        <div>我的社群</div>
        <div>{{ userCommunityInfoVo.allDirectCount }} 人</div>
      </div>

      <div class="card_item" >
        <div>{{ userCommunityInfoVo.dayDirectCount }}</div>
        <div>今日新增</div>
      </div>

      <div class="card_item" >
        <div>{{ userCommunityInfoVo.monthDirectCount }}</div>
        <div>本月新增</div>
      </div>
    </div>
  </div>
</template>
<style scoped lang="less" >
@import "index";
</style>
<script>
import {
  accountBalances,
  profit,
  turnover,
  orderCount
} from '@/api/home'
import {
  getUserCommunityInfoVoByToken
} from '@/api/community'
import { getEnableLuckDrawVo } from '@/api/luckdraw'
import {getUserInfo} from "@/api/login";
import {
  Toast, Dialog
} from "vant";
import fail from './img/fail.png'
import {getUserSugarMoneyInfo} from "@/api/transfer";
export default {
  name: 'home',
  data() {
    return {
      accountBalances: 0,
      profit: 0,
      dayTurnover: 0,
      monthTurnover: 0,
      allTurnover: 0,
      allCount: 0,
      dayCount: 0,
      monthCount: 0,
      userVo: JSON.parse(localStorage.getItem('userVo')),
      userCommunityInfoVo: {
        allDirectCount: 0,
        weekDirectCount: 0,
        monthDirectCount:0,
        dayDirectCount: 0,
      },
      sugarMoney: 0
    }
  },
  methods: {
    toRecord() {
      this.$router.push({
        name: 'transferList'
      })
    },
    toTransfer() {
      if(parseFloat(this.sugarMoney) <= 0) {
        Toast('购物金不足')
        return false
      }
      this.$router.push({
        name: 'transferSelect'
      })
    },
    draw() {
      // this.$router.push({ name: 'luckDraw' })
      getEnableLuckDrawVo({}).then(res => {
        if(res.success) {
          let luckDrawVo = res.data.luckDrawVo
          let luckDrawGoodsVoList = res.data.luckDrawGoodsVoList
          luckDrawGoodsVoList.map(item => {
            if(!item.luckDrawGoodsId) {
              item.picUrl = fail
            }
          })
          localStorage.setItem('luckDrawVo', JSON.stringify(luckDrawVo))
          localStorage.setItem('luckDrawGoodsVoList', JSON.stringify(luckDrawGoodsVoList))
          this.$router.push({ name: 'luckDraw', params: { luckDrawId: luckDrawVo.luckDrawId } })
        }else {
          Toast(res.msg)
        }
      })
    },
    poster() {
      this.$router.push({ name: 'poster' })
    },
    copy() {
      var input = document.createElement("input");   // 直接构建input
      input.value = this.userVo.userCode;  // 设置内容
      document.body.appendChild(input);    // 添加临时实例
      input.select();   // 选择实例内容
      document.execCommand("Copy");   // 执行复制
      document.body.removeChild(input); // 删除临时实例
      Toast('复制成功')
    },
    myCommunity() {
      this.$router.push({ name: 'myCommunity' })
    },
    setting() {
      this.$router.push({ name: 'setting' })
    },
    cashApply() {
      this.$router.push({ name: 'cashApply' })
    },
    turnoverDetail() {
      this.$router.push({ name: 'turnoverDetail' })
    },
    notice() {
      this.$router.push({ name: 'notice' })
    },
    back() {
      this.$router.go(-1)
    },
    getAccountBalances() {
      accountBalances({}).then(res => {
        if(res.success) {
          this.accountBalances = res.data.accountBalances
        }
      })
    },
    getProfit() {
      profit({}).then(res => {
        if(res.success) {
          this.profit = res.data.profit
        }
      })
    },
    turnover() {
      turnover({}).then(res => {
        if(res.success) {
          this.dayTurnover = res.data.dayTurnover
          this.monthTurnover = res.data.monthTurnover
          this.allTurnover = res.data.allTurnover
        }
      })
    },
    orderCount() {
      orderCount({}).then(res => {
        if(res.success) {
          this.dayCount = res.data.dayCount
          this.allCount = res.data.allCount
          this.monthCount = res.data.monthCount
        }
      })
    },
    getUserInfo() {
      getUserInfo({}).then(res => {
        if(res.success) {
          localStorage.setItem('userVo', JSON.stringify(res.data.userVo))
          this.userVo = res.data.userVo
          if(res.data.userVo.authStatus == 0) {
            console.log('未认证')
            this.authDialog()
          }
        }
      })
    },
    authDialog() {
      Dialog.confirm({
        title: '提示',
        message: '用户未完成认证，请前往认证',
        confirmButtonColor: '#1890ff',
        showCancelButton: false,
      })
        .then(() => {
          // on confirm
          this.$router.push({
            name: 'userAuth'
          })
        })
        .catch(() => {
          // on cancel
        });
    },
    getUserCommunityInfoVoByToken() {
      getUserCommunityInfoVoByToken({}).then(res => {
        if(res.success) {
          this.userCommunityInfoVo = res.data
        }
      })
    },
    getUserSugarMoneyInfo() {
      getUserSugarMoneyInfo({}).then(res => {
        if(res.success) {
          this.sugarMoney = res.data.sugarMoney
        }
      })
    }
  },
  mounted() {
    // 我的社群信息
    this.getUserCommunityInfoVoByToken()
    // 获取账户余额
    this.getAccountBalances()
    // 获取收益
    this.getProfit()
    // 获取营业额
    this.turnover()
    // 获取订单数
    this.orderCount()
    this.getUserInfo()
    // 获取购物金
    this.getUserSugarMoneyInfo()
  }
}
</script>
